(function(){
  if(window.__fl)return;window.__fl=1;
  var Q={};
  function fmt(c){return '$'+(c/100).toFixed(2)}
  function cur(data){
    var vp=document.querySelector('variant-picker');
    if(vp){
      var names=[],sel={};
      vp.querySelectorAll('input[type=radio]').forEach(function(i){if(names.indexOf(i.name)<0)names.push(i.name);if(i.checked)sel[i.name]=i.value});
      vp.querySelectorAll('select').forEach(function(s){if(names.indexOf(s.name)<0)names.push(s.name);sel[s.name]=s.value});
      if(names.length){
        var vals=names.map(function(n){return sel[n]});
        for(var k=0;k<data.v.length;k++){var v=data.v[k];if(v.o.length===vals.length&&v.o.every(function(x,j){return x===vals[j]}))return v}
        return null;
      }
    }
    var id=new URLSearchParams(location.search).get('variant'),f=null;
    data.v.forEach(function(v){if(String(v.id)===id)f=v});
    if(f)return f;
    data.v.forEach(function(v){if(v.id===data.d)f=v});
    return f||data.v[0];
  }
  function init(root){
    root.setAttribute('data-ready','1');
    var data=JSON.parse(root.querySelector('script[data-v]').textContent);
    var off=parseInt(root.getAttribute('data-off'),10)||0,pid=root.getAttribute('data-pid');
    var qty=root.querySelector('.fl-qty input'),go=root.querySelector('.fl-go'),lab=go.querySelector('.fl-go__l'),tot=go.querySelector('[data-total]');
    var opts=root.querySelectorAll('.fl-pick__opt');
    if(Q[pid])qty.value=Q[pid];
    function render(){
      var q=Math.max(1,Math.min(99,parseInt(qty.value,10)||1));
      if(String(q)!==qty.value)qty.value=q;Q[pid]=q;
      opts.forEach(function(o){var on=(o.getAttribute('data-q')==='1')?q===1:q>=2;o.classList.toggle('is-on',on);o.setAttribute('aria-checked',on?'true':'false')});
      var v=cur(data);
      if(!v||!v.a){go.disabled=true;lab.textContent=v?'Sold out':'Unavailable';tot.textContent='';return}
      go.disabled=false;if(!go.classList.contains('is-loading'))lab.textContent='Buy it now';
      var full=v.p*q,t=(off&&q>=2)?full-off:full;
      var txt=fmt(t);if(tot.textContent!==txt)tot.textContent=txt;
      root.querySelectorAll('[data-p1]').forEach(function(e){e.textContent=fmt(v.p)});
      root.querySelectorAll('[data-p2]').forEach(function(e){e.textContent=fmt(v.p*2-off)});
      root.querySelectorAll('[data-p2was]').forEach(function(e){e.textContent=fmt(v.p*2)});
    }
    opts.forEach(function(o){o.addEventListener('click',function(){qty.value=o.getAttribute('data-q');render()})});
    root.querySelectorAll('.fl-qty button').forEach(function(b){b.addEventListener('click',function(){qty.value=(parseInt(qty.value,10)||1)+parseInt(b.getAttribute('data-d'),10);render()})});
    qty.addEventListener('input',render);qty.addEventListener('change',render);
    go.addEventListener('click',function(){var v=cur(data);if(!v||!v.a)return;var q=parseInt(qty.value,10)||1;go.classList.add('is-loading');lab.textContent='Opening checkout';window.location.href='/cart/'+v.id+':'+q});
    window.addEventListener('pageshow',function(){go.classList.remove('is-loading');render()});
    root.__r=render;root.__v=function(){return cur(data)};render();
  }
  function eta(el){
    el.setAttribute('data-ready','1');
    function add(n){var d=new Date();while(n>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)n--}return d}
    function f(d){return d.toLocaleDateString('en-AU',{weekday:'short',day:'numeric',month:'short'}).replace(/,/g,'')}
    var t=el.querySelector('[data-eta]');if(t)t.textContent=f(add(parseInt(el.getAttribute('data-min'),10)||7))+' – '+f(add(parseInt(el.getAttribute('data-max'),10)||14));
  }
  function scan(){
    document.querySelectorAll('.fl-buy:not([data-ready])').forEach(init);
    document.querySelectorAll('.fl-eta:not([data-ready])').forEach(eta);
    document.querySelectorAll('.fl-buy[data-ready]').forEach(function(r){if(r.__r)r.__r()});
  }
  document.addEventListener('change',function(){setTimeout(scan,60);setTimeout(scan,400)});
  document.addEventListener('click',function(){setTimeout(scan,120);setTimeout(scan,600)});
  if(document.readyState!=='loading')scan();else document.addEventListener('DOMContentLoaded',scan);
  setInterval(scan,800);
})();
